import { Component, OnInit, Input } from '@angular/core';
import { Card } from '../../home-cards-structure';

@Component({
  selector: 'app-home-card',
  templateUrl: './home-card.component.html',
  styleUrls: ['./home-card.component.css']
})
export class HomeCardComponent implements OnInit {

  @Input() card: Card;
  onHover = false;
  constructor() { }

  ngOnInit(): void {
  }

}
